module.exports = __webpack_public_path__ + "img/setting.3e5ad7ae.svg";